<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">
      <b-tab :title="lang.tab_Tasks" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 0">

        <RequestTasksComponent :lang="lang.RequestTasks" parent="details"></RequestTasksComponent>
      </b-tab>
      <b-tab :title="lang.tab_Search" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 1">

        <ExternalSearchRequestComponent :lang="lang.Search" parent="details"></ExternalSearchRequestComponent>
      </b-tab>
      <!-- <b-tab :title="lang.tab_WhereUsed" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 2">

        
      </b-tab> -->
      
      

      


    </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import RequestTasksComponent from '@/components/shared/RequestTasksComponent'
import ExternalSearchRequestComponent from '@/components/shared/ExternalSearchRequestComponent'


export default {
  name: "Content",
  components: {
    RequestTasksComponent,
    ExternalSearchRequestComponent,
    

  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,
      
    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      appConf: 'appConf',
      currentUser: 'currentUser'
    }),
    
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    
  },
  created() {
 

    this.getTabIndex();

    

  },
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__right"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
    },
    
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__right"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__right"];
      } else {
        this.tabIndex = 0;
      }

    },
    
  },
}
</script>

<style scooped>

</style>



// WEBPACK FOOTER //
// src/components/RequestManager/Views/RequestDetails/Right/Content/Content.vue